export enum ShiftType {
   None = 0,
   MorningShift = 1,
   NightShift = 2
}
